import React, { useEffect, useState } from "react";
import "@fortawesome/fontawesome-svg-core/styles.css";

const CustomStringAttributeFilter = ({ onChange, data, initialState }) => {
  const [customStringAttributes, setCustomStringAttributes] = useState([]);

  useEffect(() => {
    // Initialize the active state based on initialState
    const updatedCustomStringAttributes = data.map((customStringAttribute) => {
      const initialCustomStringAttribute = initialState?.find(
        (initial) => initial.id === customStringAttribute.id,
      );
      return {
        ...customStringAttribute,
        active: initialCustomStringAttribute ? true : false,
      };
    });

    setCustomStringAttributes(updatedCustomStringAttributes);
  }, [data, onChange, initialState]);

  const handleCustomStringAttributeChange = (clickedCustomStringAttribute) => {
    // Update the active state of the clicked customStringAttribute
    const updatedCustomStringAttributes = customStringAttributes.map(
      (customStringAttribute) => {
        if (customStringAttribute.id === clickedCustomStringAttribute.id) {
          return {
            ...customStringAttribute,
            active: !customStringAttribute.active,
          };
        }
        return customStringAttribute;
      },
    );

    // Filter the active customStringAttributes
    const newArray = updatedCustomStringAttributes.filter(
      (customStringAttribute) => customStringAttribute.active,
    );

    // Update the state with the new active state and call the onChange callback
    setCustomStringAttributes(updatedCustomStringAttributes);

    onChange && onChange(newArray);
  };

  return (
    <>
      <div className="filters">
        <div className="filter">
          {Array.isArray(customStringAttributes) &&
            customStringAttributes
              .filter((x) => x.count > 0) // Remove filter to see all for testing
              .map((customStringAttribute) => (
                <div
                  className="element checkbox form-group"
                  key={customStringAttribute.id}
                >
                  <div className="field">
                    <div className="icheck-primary">
                      <input
                        type="checkbox"
                        id={`customStringAttributeCheckbox_${customStringAttribute.id}`}
                        aria-controls={customStringAttribute.id}
                        aria-checked={customStringAttribute.active || false}
                        checked={customStringAttribute.active || false}
                        onChange={() =>
                          handleCustomStringAttributeChange(
                            customStringAttribute,
                          )
                        }
                      />
                      <label
                        htmlFor={`customStringAttributeCheckbox_${customStringAttribute.id}`}
                      >
                        {customStringAttribute.display ??
                          customStringAttribute.name}
                        <span className="count">
                          {customStringAttribute.count === undefined
                            ? 0
                            : customStringAttribute.count}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </>
  );
};

export default CustomStringAttributeFilter;
